<template>

	<div> Hello {{ $t('world') }} </div>

</template>

<script>
export default {
	mounted() {
		console.log('mounting test');
	},
};
</script>

<style lang="scss" scoped>
div {
	background: palevioletred;
}
</style>

